
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SummaryOrder extends Vue {
    @Prop({default: null})
    private chinaAddress!: any;
}
